import { NativeElement2p8z5z0r9meck as NativeElement } from '../NativeElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../NativeElement.commonHtml.js.mjs';
import { _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr } from '../../models/data.mjs';
import { get_px1lajc6xaddk2r as get_px } from '../../models/data.js.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IconViewClass;
function IconView() {
  if (IconViewClass === VOID) {
    class $ extends NativeElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        this.native_1.setAttribute_j9pxft_k$('role', 'img');
        this.native_1.classes_1.add_utx5q5_k$('viewDraws');
        this.native_1.classes_1.add_utx5q5_k$('icon');
        this.source_1 = null;
        this.description_1 = null;
      }
      set_source_3o5lkf_k$(value) {
        this.source_1 = value;
        this.native_1.clearChildren_eufjq4_k$();
        if (value == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp = this.native_1;
          // Inline function 'kotlin.apply' call
          var this_0 = new (FutureElement())();
          this_0.tag_1 = 'svg';
          this_0.xmlns_1 = 'http://www.w3.org/2000/svg';
          this_0.setAttribute_j9pxft_k$('aria-hidden', 'true');
          var tmp0 = this_0.style_1;
          // Inline function 'com.lightningkite.kiteui.views.width' call
          var value_0 = _Dimension___get_value__impl__urhqzr(value.width_1).toString();
          tmp0.native_1.width = value_0;
          var tmp0_0 = this_0.style_1;
          // Inline function 'com.lightningkite.kiteui.views.height' call
          var value_1 = _Dimension___get_value__impl__urhqzr(value.height_1).toString();
          tmp0_0.native_1.height = value_1;
          this_0.setStyleProperty_wavvb3_k$('fill', 'currentColor');
          this_0.setStyleProperty_wavvb3_k$('stroke', 'currentColor');
          this_0.setStyleProperty_wavvb3_k$('stroke-width', '0');
          // Inline function 'kotlin.run' call
          var tmp$ret$6 = '' + value.viewBoxMinX_1 + ' ' + value.viewBoxMinY_1 + ' ' + value.viewBoxWidth_1 + ' ' + value.viewBoxHeight_1;
          this_0.setAttribute_j9pxft_k$('viewBox', tmp$ret$6);
          var _iterator__ex2g4s = value.pathDatas_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var path = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'kotlin.apply' call
            var this_1 = new (FutureElement())();
            this_1.tag_1 = 'path';
            this_1.xmlns_1 = 'http://www.w3.org/2000/svg';
            this_1.setAttribute_j9pxft_k$('d', path);
            this_0.appendChild_gtildm_k$(this_1);
          }
          var _iterator__ex2g4s_0 = value.strokePathDatas_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var path_0 = _iterator__ex2g4s_0.next_20eer_k$();
            // Inline function 'kotlin.apply' call
            var this_2 = new (FutureElement())();
            this_2.tag_1 = 'path';
            this_2.xmlns_1 = 'http://www.w3.org/2000/svg';
            this_2.setStyleProperty_wavvb3_k$('stroke-width', get_px(path_0.strokeWidth_1).toString());
            var tmp0_safe_receiver = path_0.fill_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.closestColor_akwbqu_k$();
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toWeb_1tsvdl_k$();
            this_2.setStyleProperty_wavvb3_k$('fill', tmp2_elvis_lhs == null ? 'none' : tmp2_elvis_lhs);
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$12 = path_0.strokeLineCap_1.toString().toLowerCase();
            this_2.setStyleProperty_wavvb3_k$('stroke-linecap', tmp$ret$12);
            this_2.setAttribute_j9pxft_k$('d', path_0.path_1);
            this_0.appendChild_gtildm_k$(this_2);
          }
          tmp.appendChild_gtildm_k$(this_0);
        }
      }
      set_description_s1386w_k$(value) {
        this.description_1 = value;
        if (value === '') {
          this.set_accessibleLabel_97wje2_k$(null);
          this.native_1.setAttribute_j9pxft_k$('aria-hidden', 'true');
        } else {
          this.set_accessibleLabel_97wje2_k$(value);
          this.native_1.setAttribute_j9pxft_k$('aria-hidden', null);
        }
      }
    }
    initMetadataForClass($, 'IconView');
    IconViewClass = $;
  }
  return IconViewClass;
}
//region block: exports
export {
  IconView as IconView32wln42r1v8cb,
};
//endregion

//# sourceMappingURL=IconView.commonHtml.mjs.map
